<template>
    <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-lg-6">
            <div class="vimeo-space" style="padding: 56.25% 0 0 0; position: relative;">
                <iframe src="https://player.vimeo.com/video/406583431"
                        style="height: 100%; left: 0; position: absolute; top: 0; width: 100%;" frameborder="0"
                        webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrientationVideo",
    }
</script>

<style scoped>

</style>
